<template>
    <v-main>
        <v-container
                class="fill-height"
                fluid
        >
            <v-row
                    align="center"
                    justify="center"
                    v-if="loadFlag"
            >
                <v-col
                        cols="12"
                        sm="8"
                        md="4"
                >
                    <v-card class="elevation-12">
                        <v-toolbar
                                :color="groupSetting.mainColor"
                                dark
                                flat
                        >
                            <v-img
                                    alt="Logo"
                                    class="shrink mr-2"
                                    contain
                                    :src="groupSetting.logoUrl"
                                    transition="scale-transition"
                                    :width="groupSetting.logoSize"
                            />
                            <v-toolbar-title>{{ groupSetting.groupName }} 주문확인</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon>mdi-login</v-icon>
                        </v-toolbar>
                        <v-card-text>
                            <v-form @submit.prevent>
                                <v-text-field
                                        id="password"
                                        label="패스워드"
                                        name="password"
                                        prepend-icon="mdi-lock"
                                        type="password"
                                        v-model="clientCredentials.clientPhone"
                                        @keyup="getAuthorization"
                                        ref="clientPhone"
                                ></v-text-field>
                            </v-form>
                            <span class="ml-9">* 비밀번호는 고객사 대표 연락처입니다.</span>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn :color="groupSetting.mainColor" v-on:click="getAuthorization">로그인</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
            <v-row
                    align="center"
                    justify="center"
                    v-if="!loadFlag"
            >
                <v-col
                        cols="12"
                        sm="8"
                        md="4"
                >
                    <v-card class="elevation-12">
                        <v-toolbar
                                :color="groupSetting.mainColor"
                                dark
                                flat
                        >
                            <v-img
                                    alt="Logo"
                                    class="shrink mr-2"
                                    contain
                                    :src="groupSetting.logoUrl"
                                    transition="scale-transition"
                                    :width="groupSetting.logoSize"
                            />
                            <v-toolbar-title>{{ groupSetting.groupName }} 주문확인</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon>mdi-login</v-icon>
                        </v-toolbar>
                        <v-card-text class="text-center">
                            <br />
                            <h2>정상적인 접근이 아닙니다.
                            <br /><br />
                                관리자에게 문의하세요.</h2>
                            <br />
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-main>
</template>

<script>
    export default {
        name: 'UserLogin',
        data() {
            return {
                loadFlag: true,
                clientCredentials: {
                    clientCode: "",
                    clientPhone: "",
                    orderId: ""
                },
                groupSetting: this.$store.getters.getGroupSetting
            }
        },
        watch: {
          loadFlag: function() {
              this.$forceUpdate()
          }
        },
        methods: {
            getAuthorization: function(e) {
                if(e.keyCode == 13 || e.type == 'click'){
                    this.$store.dispatch('getClientAuthorization', this.clientCredentials)
                }
            }
        },
        beforeCreate: function() {

            const clientInfo = this.$store.getters.getClientInfo
            if(clientInfo.clientCode && clientInfo.clientCode && clientInfo.clientCode == this.$route.params.clientCode){
                if(this.$route.params.orderId){
                    this.$router.push('/client/dashboard/' + clientInfo.clientCode + '/' + this.$route.params.orderId)
                }else{
                    this.$router.push('/client/dashboard/' + clientInfo.clientCode)
                }
                return false
            }

        },
        created: function() {

            let loadFlag = true
            if(location.hash == "#/client/login" || location.hash == "#/client/login/" || location.hash == "#/client/login/undefined"){
                loadFlag = false
            }
            this.loadFlag = loadFlag

            if(this.$route.params.clientCode){
                this.clientCredentials.clientCode = this.$route.params.clientCode
            }
            if(this.$route.params.orderId){
                this.clientCredentials.orderId = this.$route.params.orderId
            }
            if(this.$refs.clientPhone){
                this.$refs.clientPhone.focus()
            }

        }
    }
</script>

<style>

</style>